import { Result } from '@/core/models/Result';
import UserEntity from '@/app/features/user/entities/UserEntity';
import LivestreamProductEntity from '@/livestream/features/livestream-product/entities/LivestreamProductEntity';

type GlobalDataType = {
    customerSourceId: number;
    qrDiscountPercent: number;
    customerInfo: UserEntity | null;
    products: LivestreamProductEntity[];
};

export default class GetGlobalDataResult extends Result<GlobalDataType> {
    public data: GlobalDataType;

    public constructor() {
        super();
        this.data = {
            customerSourceId: 0,
            qrDiscountPercent: 0,
            customerInfo: null,
            products: [],
        };
    }
}
